import * as angular from 'angular';
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {BringozArray} from "../persistence-layer/bringoz-array";

angular
  .module('bringoz.admin.commons')
  .factory('$viewSettings', ViewSettingsArrayFactory);

export type $viewSettingsFactory = () => BringozArray<any>;

/* @ngInject */
function ViewSettingsArrayFactory($bringozFactory: $bringozFactory,
                             ViewSettingsAPI: BringozApi,
                             View_Settings_DS: DataStoreConfig) {

  function $viewSettings() {
    return $bringozFactory<any>(null, ViewSettingsAPI, View_Settings_DS);
  }

  return $viewSettings;
}
